import { useEffect } from 'react'
import { useOrganizationId } from '../hooks/useOrganizationId'
import { initializeSessionSecurity, cleanupSessionSecurity } from '../services/sessionSecurity'
import { useSessionGuard } from '../hooks/useSessionGuard'

/**
 * Session Security Provider
 * Wraps the app to provide session security monitoring
 */
const SessionSecurityProvider = ({ children }) => {
  const organizationId = useOrganizationId()

  // Soft session guard: checks Supabase auth and navigates via React Router
  // if the session is actually gone. This does NOT hard-reload the page.
  useSessionGuard()

  useEffect(() => {
    if (!organizationId) return

    // Initialize session security when organization is available
    // This is non-blocking - failures are expected (e.g., ad blockers blocking IP fetch)
    initializeSessionSecurity(organizationId).catch((error) => {
      // Use warn instead of error - this is expected to fail sometimes
      console.warn('Session security initialization failed (non-critical):', error.message || error)
    })

    // Cleanup on unmount
    return () => {
      cleanupSessionSecurity()
    }
  }, [organizationId])

  return <>{children}</>
}

export default SessionSecurityProvider

